<template>
  <div>

    <v-dialog v-model="active" width="600">
      <v-card>
        <v-divider/>
        <v-layout>
          <v-container>
            <v-flex xs8>
              <v-text-field v-model="name" :label="`${$t('archive.name')}`" :rules="nameRules" required></v-text-field>
            </v-flex>
            <v-flex xs8>
              <v-text-field v-model="description" :label="`${$t('department.description')}`"></v-text-field>
            </v-flex>
            <v-btn @click="emitChanges()">
              {{ $t('department.submit') }}
            </v-btn>
          </v-container>
        </v-layout>
      </v-card>
    </v-dialog>

    <slot name="activator" v-bind:on="{click: this.open}">
      <v-btn icon small>
        <v-icon block color="green darken-2" fab small style="color: #efefef" @click="(active = !active)">edit</v-icon>
      </v-btn>
    </slot>

  </div>
</template>
<script>
export default {
  props: {
    agency: {
      type: Object,
      default: () => ({
        'name': '',
        'description': ''
      })
    }
  },
  data() {
    return {
      name: "",
      description: "",
      active: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 2) || this.$t('validator.wrong_length'),
      ],
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {
    this.name = this.agency.name
    this.description = this.agency.description
  },
  methods: {
    open() {
      this.active = true
    },
    emitChanges() {
      let model = {
        'name': this.name,
        'description': this.description
      }

      let action = 'create'
      if (this.agency.id > 0) {
        action = 'update'
        model.id = this.agency.id
      }
      this.$emit(action, model)
      this.active = false
    }
  },
}
</script>

<style>

</style>
